export default "__VITE_ASSET__BgDY2FwJ__"